import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M128 48L128 24"
      />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M224 160c-14.6 51-82.2 68.8-94.2 71.6a7.3 7.3 0 01-3.6 0c-12-2.8-79.6-20.6-94.2-71.6v-34.2a8 8 0 015.5-7.6l88-29.4a8.5 8.5 0 015 0l88 29.4a8 8 0 015.5 7.6z"
      />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M128 168L128 88.4"
      />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M56 112V56a8 8 0 018-8h128a8 8 0 018 8v56"
      />
    </svg>
  );
}

export default Icon;
